function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2020, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import { DataShare } from '@carbon/react/icons';
import msgs from '../../nls/common.properties';
import config from '../../lib/shared/config';
import hrefs from '../../lib/shared/hrefs';
import PropTypes from 'prop-types';
import React from 'react';
import { WorldLevelNav } from '@console/cloud-pal-community/components/Basic';
import xhr from '../../lib/client/xhr';
import { AppContext } from './app-context.js';
var LOCAL_STORAGE_KEY = 'otc-ui.pipelineWorkerPoolsEnabled';
var DevOpsWorldLevelNav = /*#__PURE__*/function (_React$Component) {
  function DevOpsWorldLevelNav(props) {
    var _this;
    _classCallCheck(this, DevOpsWorldLevelNav);
    _this = _callSuper(this, DevOpsWorldLevelNav, [props]);
    _this.state = {};
    return _this;
  }
  _inherits(DevOpsWorldLevelNav, _React$Component);
  return _createClass(DevOpsWorldLevelNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // initialize from browser cache
      this.setState({
        pipelineWorkerPoolsEnabled: window.localStorage[LOCAL_STORAGE_KEY] === 'true'
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$context$account;
      var id = (_this$context$account = this.context.account) === null || _this$context$account === void 0 ? void 0 : _this$context$account.accountGuid;
      if (id && id !== this._lastLoadedId) {
        // fetch account settings on account load/change
        this._lastLoadedId = id;
        this.loadAccountSettings();
      }
      this._lastLoadedId = id;
    }
  }, {
    key: "items",
    value: function items() {
      var locale = this.context.locale,
        showPipelineWorkerPools = this.state.pipelineWorkerPoolsEnabled;
      return [{
        'data-item-id': 'welcome-tab',
        href: hrefs.gettingStarted(config.ENV_ID),
        label: msgs.get('left.nav.header', locale),
        icon: DataShare
      }, {
        'data-item-id': 'toolchains-tab',
        label: msgs.get('toolchains', locale),
        href: hrefs.toolchains()
      }].concat(_toConsumableArray(showPipelineWorkerPools ? [{
        'data-item-id': 'pipeline-worker-pools-tab',
        label: msgs.get('pipeline-worker-pools', locale),
        href: hrefs.pipelineWorkerPools(config.ENV_ID)
      }] : []));
    }

    /*
     * Get this from the server to avoid exposing allowlisted account ids to the browser.
     */
  }, {
    key: "loadAccountSettings",
    value: function loadAccountSettings() {
      var _this2 = this;
      var accountGuid = this.context.account.accountGuid;
      xhr("".concat(config.CONTEXT_PATH, "/account-settings?bss_account=").concat(accountGuid), {
        dataType: 'json'
      }, function (error, data) {
        if (error) {
          // fail silently and use already-cached state
          console.error(error);
          return;
        }
        var pipelineWorkerPoolsEnabled = !!(data !== null && data !== void 0 && data.pipelineWorkerPoolsEnabled);
        _this2.setState({
          pipelineWorkerPoolsEnabled: pipelineWorkerPoolsEnabled
        });
        try {
          // update client side cache
          window.localStorage.setItem(LOCAL_STORAGE_KEY, "".concat(pipelineWorkerPoolsEnabled));
        } catch (e) {
          // continue; this can happen if storage is full
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var activeItem = this.props.activeItem,
        locale = this.context.locale,
        title = msgs.get('left.nav.header', locale);
      var allItems = this.items();
      var activeHref = (allItems.find(function (i) {
        return i['data-item-id'] === activeItem;
      }) || {}).href;
      return (
        /*#__PURE__*/
        // top-level is no longer a link, with the advice:
        // per https://github.ibm.com/ibmcloud/cloud-pal-community/blame/master/MIGRATION.md#L732
        // > If using titleHref previously, provide your title page as an item and your service as the title prop.
        // so above item welcome-tab is providing icon and label "DevOps"
        React.createElement(WorldLevelNav, {
          items: allItems,
          title: title,
          activeHref: activeHref
        })
      );
    }
  }]);
}(React.Component);
export { DevOpsWorldLevelNav as default };
DevOpsWorldLevelNav.contextType = AppContext;
DevOpsWorldLevelNav.propTypes = {
  activeItem: PropTypes.string
};